var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2267 6.68016C24.96 5.8935 24.2133 5.3335 23.3333 5.3335H8.66667C7.78667 5.3335 7.05333 5.8935 6.77333 6.68016L4 14.6668V25.3335C4 26.0668 4.6 26.6668 5.33333 26.6668H6.66667C7.4 26.6668 8 26.0668 8 25.3335V24.0002H24V25.3335C24 26.0668 24.6 26.6668 25.3333 26.6668H26.6667C27.4 26.6668 28 26.0668 28 25.3335V14.6668L25.2267 6.68016ZM9.13333 8.00016H22.8533L24.24 12.0002H7.74667L9.13333 8.00016ZM25.3333 21.3335H6.66667V14.6668H25.3333V21.3335Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0002C11.1046 20.0002 12 19.1047 12 18.0002C12 16.8956 11.1046 16.0002 10 16.0002C8.89543 16.0002 8 16.8956 8 18.0002C8 19.1047 8.89543 20.0002 10 20.0002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.0002C23.1046 20.0002 24 19.1047 24 18.0002C24 16.8956 23.1046 16.0002 22 16.0002C20.8954 16.0002 20 16.8956 20 18.0002C20 19.1047 20.8954 20.0002 22 20.0002Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.3cbaa4ba42544e62b5469d4d539e3b2d.svg";
export { ForwardRef as ReactComponent };